import { IonChip, IonContent, IonGrid, IonRow } from '@ionic/react'
import React, { useState, useEffect } from 'react'
import Api from '../../services/Api'

interface ComponentProps {
  handleCategory: Function
  category: string
}

export const CreateCategory = ({ handleCategory, category } : ComponentProps) => {
  const api = Api.getInstance()
  const categories = ['Möte', 'Distanspromenad', 'Lunch', 'Fika', 'Hund', 'Problemlösning', '50/50', '1-on-1']
  const [picked, setPicked] = useState('')

  useEffect(() => {
    if(category !== '') {
      setPicked(category)
    }
  }, [category])

  useEffect(() => {
    handleCategory(picked)
  }, [picked])

  const checkPicked = (category: string) => {
    if(category === picked) {
      return false
    } else {
      return true
    }
  }

  return (
    <IonContent>
      <IonGrid>
        <IonRow className="p-2 color_blue">
          <h1 className="text_center">Välj en kategori (ej obligatoriskt)</h1>
        </IonRow>
        <IonRow>
          { categories.map((category: string, index: any) => {
            return <IonChip
              key={'category' + index} 
              className="p-2 m-2" 
              color="teal" 
              outline={checkPicked(category)}
              id={category} 
              onClick={() => {
                setPicked(category)
              }}>
              { category }
            </IonChip>})
          }
        </IonRow>
      </IonGrid>
    </IonContent>
  )
}

export default CreateCategory
